export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datos de registro"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Guardar"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmado"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Público"])}
}